import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';
import { FiMaximize } from "react-icons/fi";
import { Redirect, useHistory } from 'react-router-dom';
import { RiSlideshow3Line } from "react-icons/ri";
import { BsCollectionPlay } from "react-icons/bs";
import { MdOutlineWebAssetOff } from "react-icons/md";
import { API_ENDPOINTS } from '../frameWork/utils/keyapi-endpoints';
import { useGetQuery } from '../frameWork/rest';
import { useDispatch, useSelector } from 'react-redux';
import { changeIsSlideShowAction, changeSidebarFilterType, changeSidebarType } from '../redux/actions';
import { SideBarFilterTypes, SideBarTypes } from '../constants';
import { Button, Progress } from 'antd';
import { IoPauseCircleOutline, IoPlayCircleOutline, IoStopCircleOutline } from "react-icons/io5";
import { FaRegPlayCircle, FaRegStopCircle, FaRegPauseCircle } from "react-icons/fa";

function getLeafIds(arr: any) {
    let leafIds: any = [];

    function findLeaves(nodes: any) {
        nodes.forEach((node: any) => {
            if (!node.children || node.children.length === 0) {
                leafIds.push(node.id);
            } else {
                findLeaves(node.children);
            }
        });
    }

    findLeaves(arr);
    return leafIds;
}

const SlideShowScreen = ({ menuItems }: any) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { isSlideShow } = useSelector((state: any) => state.DashboardPage);
    const [counter, setCounter] = useState(30);
    const [isPaused, setIsPaused] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        let elem = document.querySelector('.maximize-icon');
        if (elem) elem.setAttribute('data-toggle', 'fullscreen');
        return () => {
            if (elem) {
                elem.removeAttribute('data-toggle');
            }
        };
    }, []);

    useEffect(() => {
        let timer:any;
        let countdown:any;
        let menuList:any = [];
        if (isSlideShow) {
            if (menuItems && menuItems.length > 0 && menuItems !== '1') {
                menuList = getLeafIds(menuItems.filter((x:any) => x.id === '92047d21-6871-ed11-ac26-14d64d18fb57'));
            }
            if (menuList.length > 0) {
                timer = setInterval(() => {
                    if (!isPaused) {
                        const s_MenuId = menuList[currentIndex];
                        history.replace(`/dashboard/dashboardPage/${s_MenuId}`);
                        setCurrentIndex((prevIndex) => (prevIndex + 1) % menuList.length);
                        setCounter(30); // بازنشانی شمارنده به ۳۰ ثانیه
                    }
                }, 30000); // 30000 میلیثانیه = 30 ثانیه

                countdown = setInterval(() => {
                    if (!isPaused) {
                        setCounter((prevCounter) => prevCounter > 0 ? prevCounter - 1 : 30);
                    }
                }, 1000); // شمارنده هر ثانیه یک واحد کم میشود

                return () => {
                    clearInterval(timer);
                    clearInterval(countdown);
                };
            }
        }
    }, [isSlideShow, menuItems, history, isPaused, currentIndex]);




    const toggleFullscreen = () => {
        dispatch(changeSidebarType(SideBarTypes.LEFT_SIDEBAR_TYPE_CONDENSED));
        dispatch(changeSidebarFilterType(SideBarFilterTypes.LEFT_SIDEBAR_FILTER_TYPE_CONDENSED));
        dispatch(changeIsSlideShowAction(!isSlideShow))
        let document: any = window.document;

        if (
            !document.fullscreenElement &&
            /* alternative standard method */ !document.mozFullScreenElement &&
            !document.webkitFullscreenElement
        ) {
            // current working methods
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen();
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }

        // handle fullscreen exit
        const exitHandler = () => {
            if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
                document.body.classList.remove('fullscreen-enable');
                dispatch(changeIsSlideShowAction(false))
            }
        };
        document.addEventListener('fullscreenchange', exitHandler);
        document.addEventListener('webkitfullscreenchange', exitHandler);
        document.addEventListener('mozfullscreenchange', exitHandler);
    };

    const twoColors: any = {
        '0%': '#ffccc7',
        '50%': '#ffe58f',
        '100%': '#87d068',
    };

    const togglePause = () => {
        setIsPaused(!isPaused);
    };

    return (
        <>
            {isSlideShow && (
                <>
                    <Progress
                        //style={{padding:9}}
                        className="custom-progress"
                        size={40}
                        type="circle"
                        percent={(counter / 30) * 100}
                        status="active"
                        format={() => counter}
                        strokeColor={twoColors}
                    />

                    <Dropdown>
                        <Dropdown.Toggle
                            as="a"
                            id="dropdown-languages"
                            onClick={() => togglePause()}
                            className="nav-link cursor-pointer arrow-none">
                            <div className="sanjabRightsidebar">
                                {isPaused ? <FaRegPlayCircle style={{ fontSize: 24, color: 'white' }} /> : <FaRegPauseCircle style={{ fontSize: 24, color: 'white' }} />}
                            </div>
                        </Dropdown.Toggle>
                    </Dropdown>
                </>
            )}


            <Dropdown>
                <Dropdown.Toggle
                    as="a"
                    id="dropdown-languages"
                    onClick={() => toggleFullscreen()}
                    className="nav-link cursor-pointer arrow-none">
                    <div className="sanjabRightsidebar">
                        {isSlideShow ? <FaRegStopCircle title="توقف اسلاید صفحات داشبورد" style={{ fontSize: 24, color: 'white' }} /> : <BsCollectionPlay title="نمایش اسلاید صفحات داشبورد" style={{ fontSize: 22, color: 'white' }} />}
                    </div>
                </Dropdown.Toggle>
            </Dropdown>
        </>
    );
};


export default SlideShowScreen;
